import OrganizationOnboarding from './OrganizationOnboarding';

export default OrganizationOnboarding;
